import { render, staticRenderFns } from "./FunctionalFloating.vue?vue&type=template&id=a4901c8e&scoped=true&"
import script from "./FunctionalFloating.vue?vue&type=script&lang=js&"
export * from "./FunctionalFloating.vue?vue&type=script&lang=js&"
import style0 from "./FunctionalFloating.vue?vue&type=style&index=0&id=a4901c8e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4901c8e",
  null
  
)

export default component.exports